export const routes_help = [
    {
        path: 'manuales',
        name: 'Manuales lista',
        component: () => import('./List')
    },
]